/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCalendarEvent: {
  name: 'calendar-event';
  data: string;
} = {
  name: 'calendar-event',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 1a.5.5 0 0 0-1 0v1.5h-5V1a.5.5 0 0 0-1 0v1.5H3A1.5 1.5 0 0 0 1.5 4v10A1.5 1.5 0 0 0 3 15.5h10a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 13 2.5h-1.5V1Zm-7 3v-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5h-1.5V4a.5.5 0 0 1-1 0v-.5h-5V4a.5.5 0 0 1-1 0Zm6.5 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
